export default "__VITE_ASSET__bc4dc919__"